import { Box, Stack, Tooltip, styled, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../../../redux/auth';
import { AvatarGlobal } from '../../../UI/AvatarGlobal';
import {
  ButtonAcount,
  Icon,
  SupportingText,
  Text,
  TextEmailTooltip,
  TextSection,
  TextUserTooltip,
  TooltipContent,
} from './StyledComponentsMenu';

const AccountContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 8px',
  boxSizing: 'border-box',
});

const StackUser = styled(Stack)(({ open }) => ({
  justifyContent: 'flex-start',
  alignItems: 'center',
}));

const BoxAvatar = styled(Box)(({ open }) => ({
  margin: '0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    ...(open
      ? {}
      : {
          boxShadow: '0 0 0 6px rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
        }),
  },
}));

export const AcountItemDesktop = ({ user, open, userNotOB }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCloseUserMenu = async () => {
    await dispatch(signOut());
  };

  const handleNavigateProfile = () => {
    const destination = userNotOB ? '/myaccount' : '/completeregistration';
    navigate(destination);
  };

  const iconsLogout = '../../../assets/images/log-out.svg';

  return (
    <AccountContainer sx={{ flexDirection: open ? 'row' : 'column' }}>
      <StackUser sx={{ flexDirection: open ? 'row' : 'column' }}>
        {!open ? (
          <Tooltip
            title={
              <TooltipContent onClick={handleNavigateProfile} style={{ cursor: 'pointer' }}>
                <TextUserTooltip>{`${user?.name} ${user?.['custom:paternal-surname']}`}</TextUserTooltip>
                <TextEmailTooltip>{user?.email}</TextEmailTooltip>
              </TooltipContent>
            }
            placement='right'
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: theme.palette.white.main,
                  color: theme.palette.primary.dark,
                },
              },
            }}>
            <BoxAvatar open={open} onClick={handleNavigateProfile} sx={{ cursor: 'pointer' }}>
              <AvatarGlobal width='40px' height='40px' />
            </BoxAvatar>
          </Tooltip>
        ) : (
          <BoxAvatar
            open={open}
            onClick={handleNavigateProfile}
            sx={{
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <AvatarGlobal width='40px' height='40px' />
          </BoxAvatar>
        )}

        {open && (
          <TextSection
            onClick={handleNavigateProfile}
            sx={{
              cursor: 'pointer',
            }}>
            <Text sx={{ marginLeft: '10px' }}>
              {`${user?.name} ${user?.['custom:paternal-surname']}`}
            </Text>
            <SupportingText sx={{ marginLeft: '10px' }}>{user?.email}</SupportingText>
          </TextSection>
        )}
      </StackUser>
      <Stack>
        <Icon>
          <ButtonAcount onClick={handleCloseUserMenu}>
            <img src={iconsLogout} alt='logout' />
          </ButtonAcount>
        </Icon>
      </Stack>
    </AccountContainer>
  );
};
